import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "InfoRequest" })
export default class InfoRequest extends Vue {
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public isPrivacyPolicyShow: boolean = false;
    public privacyPolicy: string = null;
    public formData: any = { zone: null };
    public validationErrors: any[] = [];
    public provinces: any[] = [];

    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly originPage: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        const result = (await Axios.post(this.routes.SoleDiCasa_GetInfoRequestData, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken()} })).data;
        this.privacyPolicy = Object.freeze(result.privacyPolicy);
        this.provinces = result.provinces;

        this.setRecaptcha();
    }

    public setRecaptcha() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public async showPrivacyPolicy() {
        this.isPrivacyPolicyShow = !this.isPrivacyPolicyShow;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];

        this.isLoading = true;

        try {
            await Axios.post(this.routes.SoleDiCasa_InfoRequestSubmit, this.formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken(), "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } });

            this.isSuccess = true;

            GTagHelper.sendEvent("form_submit", "soledicasa_info_request");
            (<any>window).gtag('event', 'conversion', {'send_to': 'AW-412883659/fCJGCO62-J0ZEMu18MQB'});
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }

            (<any>window).grecaptcha.reset();
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};